import React, { useEffect } from 'react';
import './Home.css';
import Navbar from '../H&F/Navbar';
import Footer from '../H&F/Footer';
import WATMAN1 from '../images/WATMAN1.webp';
import Discliamber from './Discliamer'


import WATMAN2 from '../images/WATMAN2.webp';
import WATMAN3 from '../images/WATMAN3.webp';
import WATMAN4 from '../images/WATMAN4.webp';
import WATMAN5 from '../images/WATMAN5.webp';
import WATMAN6 from '../images/WATMAN6.webp';
export default function WATERHEATERSERVICE() {

useEffect(() => {
            window.scrollTo(0, 0); // Scroll to the top of the page
          }, []);

        
const handleSubmit = async (e) => {
  e.preventDefault();
  const form = e.target;

   const formData = {
    name: form.name.value,
    phone: form.phone.value,
    location: form.location.value,
    issue: `  ${form.issue.value}
    
    - this calls coming from madurai 2.0 Nagaraj Account (HomeApplianceServiceMadurai.in)
    `,  
    toMail: "expresshelplinecare@gmail.com",
  };


  const spinner = document.getElementById("spinnerOverlay");
  if (spinner) spinner.style.display = "flex";

  try {
    const res = await fetch(
      "https://form.e2ecrm.in/api/sendmail",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      }
    );

    if (!res.ok) {
      throw new Error(`Server responded with ${res.status}`);
    }

    let data;
    try {
      data = await res.json();
    } catch {
      throw new Error("Invalid JSON response from server");
    }

    alert("Thank you! Your service request is confirmed. Our engineer will call you shortly.");
    form.reset();
  } catch (err) {
    console.error("Form submit error:", err);
    alert(`Error sending complaint: ${err.message}`);
  } finally {
    if (spinner) spinner.style.display = "none";
  }
};
 



  return (
    <>
                    <div><Navbar /></div>
              
                   
                      <section id="hero" style={{ backgroundImage: `url(${WATMAN1})`}}>
                        <div className="hero-content">
                          <h1>Trusted Water Heater Services</h1>
<p>Ensure hot water whenever you need it. Our technicians repair and maintain all water heater brands quickly and safely.</p>
 <a href="tel:+918610867933" className="hero-btn">+91 86108 67933</a>
                        </div>
                        
      {/* Right Form */}
      <div className="form-container">
        <form id="bookingForm" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Enter your full name"
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Enter your mobile number"
            required
          />
          <input
            type="text"
            name="location"
            placeholder="Enter your complete address"
            required
          />
          <textarea
            name="issue"
            placeholder="Describe your appliance problem"
            required
          ></textarea>
             <p
  style={{
    marginTop: "12px",
    fontSize: "14px",
    color: "#ffffff",
    fontWeight: "700",
    textAlign: "center",
  }}
>
  Your information is kept secure and used only for your service request.
</p>
          <button type="submit">Book Complaint</button>
        </form>
      </div>
     

    {/* Dot Loading */}
    <div id="spinnerOverlay" className="spinner-overlay">
      <div className="dot-loader">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p className="loading-text">Booking your complaint</p>
    </div>
 
                      </section>
              
              
              
{/*               
                      <section class="contact-icons">
                <div class="contact-item phone">
                  <a href="tel:+918610867933" class="icon-link">
                    <span class="icon phone-icon"></span>
                    <h5>Call Now</h5>
                  </a>
                </div>
                <div class="contact-item whatsapp">
                  <a href="https://wa.me/8610867933" class="icon-link">
                    <span class="icon whatsapp-icon fab fa-whatsapp"></span>
                    <h5>WhatsApp Now</h5> 
                  </a>
                </div>
                <div class="contact-item mail">
                  <a href="#" class="icon-link">
                    <span class="icon mail-icon"></span>
                    <h5>Email Now</h5>
                  </a>
                </div>
              </section>
               */}
              
              
              
              
              
              
              
              
              
              
                      {/* <section id="about">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                      <h2>About Us</h2>
                      <p class="about-description">
                        We are a trusted home appliance service company with over 6 years of experience providing exceptional service and 100% customer satisfaction. Our experts are skilled in servicing a wide range of home appliances, ensuring that your household operates smoothly.
                      </p>
              
                      <div class="services">
                        <div class="service-item">
                          <img src={WASHIGIMAGE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
                          <h3 class="service-title">Washing Machine Service</h3>
                        </div>
                        <div class="service-item">
                        <img src={ACSERVICE1} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
                          <h3 class="service-title" id="UPDOWN">AC Service</h3>
                        </div>
                        <div class="service-item">
                        <img src={FRIDGESERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
                          <h3 class="service-title" id="UPDOWN">TV Service</h3>
                        </div>
                        <div class="service-item">
                        <img src={MICROSERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
                          <h3 class="service-title">Microwave Oven Service</h3>
                        </div>
                        <div class="service-item">
                        <img src={TVSERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
                          <h3 class="service-title">Fridge Service</h3>
                        </div>
                        <div class="service-item">
                        <img src={WATERHEATERSERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
                          <h3 class="service-title">Water Heater Service</h3>
                        </div>
                        <div class="service-item">
                        <img src={WATERPURIFIERSERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
                          <h3 class="service-title">Water Purifier Service</h3>
                        </div>
                      </div>
              
                      <p class="about-footer">
                        With over 6+ years of experience and a 100% customer satisfaction guarantee, we ensure your appliances are in good hands.
                      </p>
                    </div>
                  </div>
                </div>
              </section>
              
               */}
              
              
              
              
              
              
              
              <section id="how-we-work">
                <h2>How We Work</h2>
                <div class="work-cards">
                  <div class="work-card">
                    <i class="fas fa-bullhorn"></i>
                    <h3>Promotion</h3>
                    <p>We promote our website using Google Ads to get daily regular customers.</p>
                  </div>
                  <div class="work-card">
                    <i class="fas fa-phone-alt"></i>
                    <h3>Contact Us</h3>
                    <p>Customers can reach us directly via the phone call option available on our website.</p>
                  </div>
                  <div class="work-card">
                    <i class="fas fa-clipboard-list"></i>
                    <h3>Complaint Registration</h3>
                    <p>Our customer team registers the issue and forwards it to our technician.</p>
                  </div>
                  <div class="work-card">
                    <i class="fas fa-calendar-check"></i>
                    <h3>Technician Visit</h3>
                    <p>Our technician gets an appointment and visits the customer's place to resolve the issue within 3-4 hours.</p>
                  </div>
                  <div class="work-card">
                    <i class="fas fa-money-check-alt"></i>
                    <h3>Service Charge</h3>
                    <p>The basic service charge is ₹300 across Tamil Nadu. Spare parts charges are separate.</p>
                  </div>
                </div>
              </section>
              
              
              <section id="gallery">
                <h2>Our Gallery</h2>
                <div class="gallery-grid">
                  <div class="gallery-item large-item">
                    <img src={WATMAN1} alt="Image 1"/>
                  </div>
                  <div class="gallery-item medium-item" >
                    <img src={WATMAN2} alt="Image 2"/>
                  </div>
                  <div class="gallery-item medium-item" >
                    <img src={WATMAN3} alt="Image 3"/>
                  </div>
                  <div class="gallery-item large-item">
                    <img src={WATMAN4} alt="Image 4"/>
                  </div>
                  <div class="gallery-item medium-item" >
                    <img src={WATMAN5} alt="Image 5"/>
                  </div>
                  <div class="gallery-item medium-item" >
                    <img src={WATMAN6} alt="Image 6"/>
                  </div>
                
                </div>
              </section>
              
              
              <section id="tech-special">
                <h2>Our Key Benefits</h2>
                <div class="benefit-cards">
                  <div class="benefit-card">
                    <i class="fas fa-cogs"></i>
                    <h3>Tech Specialist</h3>
                    <p>Our team consists of highly skilled technicians who specialize in all home appliance repairs.</p>
                  </div>
                  <div class="benefit-card">
                    <i class="fas fa-wrench"></i>
                    <h3>Quick Fixer</h3>
                    <p>We diagnose and fix issues quickly, minimizing any inconvenience to our customers.</p>
                  </div>
                  <div class="benefit-card">
                    <i class="fas fa-truck-fast"></i>
                    <h3>Fast Delivery</h3>
                    <p>We offer quick response times and arrive promptly at your location to deliver our services.</p>
                  </div>
                  <div class="benefit-card">
                    <i class="fas fa-users"></i>
                    <h3>Customer Friendly</h3>
                    <p>Our customer support team is available to assist you every step of the way with a friendly approach.</p>
                  </div>
                  <div class="benefit-card">
                    <i class="fas fa-check-circle"></i>
                    <h3>High Quality Work</h3>
                    <p>We ensure that every service we offer meets the highest quality standards and customer satisfaction.</p>
                  </div>
                </div>
              </section>
              
              
              
              
              
              
              
              
              
              
              <section id="our-services">
                <h2>Our Services</h2>
                <div class="container">
                 
                 
                  <div class="row service-item-washing-machine">
                    <div class="col-md-6">
                      <img src={WATMAN1} alt="Washing Machine Service" title="Washing Machine Service" class="img-fluid" />
                    </div>
                    <div class="col-md-6">
                      <h3 id="service-heading-washing-machine">Water Heater Service</h3>
                      <p id="service-description-washing-machine">Choose our water heater service for thorough and professional repairs that ensure efficient heating performance and long-lasting reliability for your home.</p>
                    </div>
                  </div>
              
                
                  <div class="row service-item-ac-service">
                    <div class="col-md-6">
                      <img src={WATMAN2} alt="AC Service" title="AC Service" class="img-fluid" />
                    </div>
                    <div class="col-md-6">
                      <h3 id="service-heading-ac-service">Installation</h3>
                      <p id="service-description-ac-service">Our water heater installation service ensures your appliance is set up correctly, providing efficient heating and energy savings for your home.</p>
                    </div>
                  </div>
              
               
                  <div class="row service-item-fridge-service">
                    <div class="col-md-6">
                      <img src={WATMAN3} alt="Fridge Service" title="Fridge Service" class="img-fluid" />
                    </div>
                    <div class="col-md-6">
                      <h3 id="service-heading-fridge-service">Voltage</h3>
                      <p id="service-description-fridge-service">We offer comprehensive water heater voltage checkup services that ensure safe and efficient operation, optimizing performance and extending the lifespan of your appliance.</p>
                    </div>
                  </div>
              
                 
                  <div class="row service-item-tv-service">
                    <div class="col-md-6">
                      <img src={WATMAN4} alt="TV Service" title="TV Service" class="img-fluid" />
                    </div>
                    <div class="col-md-6">
                      <h3 id="service-heading-tv-service">Cleaning Service</h3>
                      <p id="service-description-tv-service">Our water heater cleaning service ensures your appliance runs efficiently, with expert cleaning solutions that maintain optimal heating performance and extend its lifespan.</p>
                    </div>
                  </div>
              
                  
                  <div class="row service-item-microwave-oven-service">
                    <div class="col-md-6">
                      <img src={WATMAN5} alt="Microwave Oven Service" title="Microwave Oven Service" class="img-fluid" />
                    </div>
                    <div class="col-md-6">
                      <h3 id="service-heading-microwave-oven-service">Water Bloack</h3>
                      <p id="service-description-microwave-oven-service">Get reliable water block repair services for your water heater, ensuring efficient performance and durability. We handle all types of blockages with precision to restore proper functionality.</p>
                    </div>
                  </div>
              
                  
                  <div class="row service-item-water-heater-service">
                    <div class="col-md-6">
                      <img src={WATMAN6} alt="Water Heater Service" title="Water Heater Service" class="img-fluid" />
                    </div>
                    <div class="col-md-6">
                      <h3 id="service-heading-water-heater-service">Inspection</h3>
                      <p id="service-description-water-heater-service">Ensure optimal heating with our expert water heater inspection service, designed to identify and address issues, maintaining your unit effectively for long-lasting performance.</p>
                    </div>
                  </div>
              
                 
                  
                </div>
              </section>
              
              <section id="working-hours">
                <h2>Our Working Hours</h2>
                <div class="container">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="working-day">
                      <p id="sunday" className="day">Sunday: <span className="status" style={{ color: 'red' }}>Closed</span></p>
              
              
              
                      </div>
                      <div class="working-day">
                        <p id="monday" class="day">Monday: <span class="status">9 AM - 9 PM</span></p>
                      </div>
                      <div class="working-day">
                        <p id="tuesday" class="day">Tuesday: <span class="status">9 AM - 9 PM</span></p>
                      </div>
                      <div class="working-day">
                        <p id="wednesday" class="day">Wednesday: <span class="status">9 AM - 9 PM</span></p>
                      </div>
                      <div class="working-day">
                        <p id="thursday" class="day">Thursday: <span class="status">9 AM - 9 PM</span></p>
                      </div>
                      <div class="working-day">
                        <p id="friday" class="day">Friday: <span class="status">9 AM - 9 PM</span></p>
                      </div>
                      <div class="working-day">
                        <p id="saturday" class="day">Saturday: <span class="status">9 AM - 9 PM</span></p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              
              
              
              
              
              
              
              
              <section id="faq-section">
                <h2>Frequently Asked Questions (FAQ)</h2>
              
                <table class="table table-striped">
                <thead>
  <tr>
    <th>Service</th>
    <th>Question</th>
    <th>Answer</th>
  </tr>
</thead>
<tbody>
  <tr>
    <td>Water Heater Service</td>
    <td>How often should I service my water heater?</td>
    <td>It is recommended to service your water heater at least once a year to maintain optimal heating performance and avoid unexpected breakdowns.</td>
  </tr>
  <tr>
    <td>Water Heater Service</td>
    <td>How do I know when my water heater needs servicing?</td>
    <td>If your water heater is making strange noises, not heating properly, or leaking water, it’s time for a service.</td>
  </tr>
  <tr>
    <td>Water Heater Service</td>
    <td>What are the signs that my water heater needs a repair?</td>
    <td>Common signs include inconsistent heating, strange noises, or water leakage around the unit.</td>
  </tr>
  <tr>
    <td>Water Heater Service</td>
    <td>Why is my water heater not heating properly?</td>
    <td>This could be due to a faulty heating element, thermostat issues, or sediment buildup. A professional service is recommended to identify the issue.</td>
  </tr>
  <tr>
    <td>Water Heater Service</td>
    <td>What should I do if my water heater is leaking water?</td>
    <td>Water leakage can occur due to a broken valve, damaged seals, or a corroded tank. It’s best to get it inspected by a technician to prevent further damage.</td>
  </tr>
  <tr>
    <td>Water Heater Service</td>
    <td>How can I tell if my water heater’s heating element needs servicing?</td>
    <td>If your water heater is not producing hot water or taking longer to heat, the heating element may need servicing.</td>
  </tr>
  <tr>
    <td>Water Heater Service</td>
    <td>When should I flush my water heater?</td>
    <td>It is recommended to flush your water heater every 6-12 months to remove sediment buildup and improve heating efficiency. We provide professional flushing services.</td>
  </tr>
</tbody>

       
                </table>
              </section>
              
              
              
              
              
              <div><Discliamber/></div>
                    <div><Footer /></div>
                  </>
       
       
       
  )
}
